// extracted by mini-css-extract-plugin
export default {"contractResponsibles":"ContractResponsibles_contractResponsibles__-hAFe"};